<template></template>
<script>
export default {
  name: "distributors"
};
</script>

<style lang="scss" scoped>
</style>